import classNames from "classnames";
import styles from "./styles.module.css";
import { forwardRef } from "react";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  checked?: boolean;
  className?: string;
  labelClassName?: string;
  containerClassName?: string;
  children?: string;
}

export const AppCheckbox = forwardRef<HTMLInputElement, Props>(
  (
    {
      id,
      checked,
      className,
      labelClassName,
      containerClassName,
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={classNames(styles.container, containerClassName)}>
        <input
          type="checkbox"
          id={id}
          className={classNames(
            styles.checkbox,
            { [styles.checked]: checked },
            className,
          )}
          ref={ref}
          {...props}
        />
        <label
          htmlFor={id}
          className={classNames(styles.label, labelClassName)}
        >
          {children}
        </label>
      </div>
    );
  },
);
